/**
 * This works like Partial except the keys passed must be implemented.
 */
export type SemiPartial<BASE, KEYS extends keyof BASE> = Partial<BASE> & Pick<BASE, KEYS>;
